import { FrequencyData } from '../types/medication.type'

type StringObject = Record<string, string>

export const filterObjectByValue = (obj: StringObject, filterValue: string): StringObject => {
  return Object.entries(obj).reduce((acc: StringObject, [key, value]) => {
    if (value === filterValue) {
      acc[key] = value
    }
    return acc
  }, {})
}

export function removeEmptyFields(obj: any) {
  for (const key in obj) {
    if (obj[key] && typeof obj[key] === 'object') {
      obj[key] = removeEmptyFields(obj[key])
    } else if (obj[key] === undefined || obj[key] === null || obj[key] === '') {
      delete obj[key]
    }
  }
  return obj
}

// Recursive function to clean an object
type GenericObject = Record<string, any>

const isObject = (value: any): value is Record<string, any> =>
  value && typeof value === 'object' && !Array.isArray(value)

export const cleanObject = <T extends GenericObject>(obj: T): T => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (value === undefined || value === '') {
      // Skip keys with undefined or empty string values
      return acc
    } else if (isObject(value)) {
      // Recursively clean nested objects
      const cleanedValue = cleanObject(value)
      if (Object.keys(cleanedValue)?.length > 0) {
        ;(acc as GenericObject)[key] = cleanedValue // Type assertion to avoid error
      }
    } else {
      // Keep all other values
      ;(acc as GenericObject)[key] = value // Type assertion to avoid error
    }
    return acc
  }, {} as T)
}

const isEmptyValue = (value: any): boolean => {
  return (
    value === undefined ||
    value === null ||
    value === '' ||
    (Array.isArray(value) && value?.length === 0) ||
    (typeof value === 'string' && value.trim() === '')
  )
}

export const removeEmptyValues = (data: FrequencyData): FrequencyData => {
  const cleanedData: FrequencyData = {} as FrequencyData

  Object.entries(data).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      const cleanedArray = value.filter(item => !isEmptyValue(item))
      if (cleanedArray?.length > 0) {
        ;(cleanedData[key as keyof FrequencyData] as unknown as string[]) = cleanedArray
      }
    } else if (typeof value === 'string') {
      if (!isEmptyValue(value)) {
        // @ts-ignore
        cleanedData[key as keyof FrequencyData] = value.trim()
      }
    } else if (!isEmptyValue(value)) {
      cleanedData[key as keyof FrequencyData] = value
    }
  })

  return cleanedData
}
